import type { PixatwinBottomMenuPanelProps } from "@/sdk";
import { MeasurementPanel } from "@/components/bottom-menu/MeasurementPanel";

export const MeasurementBottomMenuPanel = ({
  onClosePanel,
}: PixatwinBottomMenuPanelProps) => {
  return <MeasurementPanel onStartMeasurement={onClosePanel} />;
};
